import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Formik, Field} from 'formik';
import Button from '../library/FormControls/Button';
import styles from './css/LeadForm.styl';
import SpinnerIcon from '../library/Spinner/SpinnerIcon';
import FormikTextInput from './FormikTextInput';
import classnames from 'classnames';

const cx = classnames.bind(styles);

class LeadForm extends Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitText: PropTypes.string.isRequired,
    renderSuccess: PropTypes.func.isRequired,
    fields: PropTypes.array.isRequired,
  };

  static defaultProps = {
    styleMods: {},
  };

  render() {
    const {
      fields,
      submitText,
      renderSuccess,
      onSubmit,
      initialValues,
      styleMods,
    } = this.props;

    const classNames = {
      LeadForm: true,
      EmailOnly: styleMods.emailOnly,
    };

    return (
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({isSubmitting, status = {}, dirty, isValid}) => {
          if (status.success) {
            return renderSuccess();
          }

          if (status.loading) {
            return (
              <div style={{textAlign: 'center'}}>
                <SpinnerIcon size={60} />
              </div>
            );
          }

          return (
            <Form className={cx(classNames)}>
              {status.error && (
                <p className={styles.FormError}>
                  Sorry, something went wrong. Please try again later.
                </p>
              )}
              {fields.map(field => {
                return (
                  <Field
                    key={field.name}
                    component={FormikTextInput}
                    {...field}
                  />
                );
              })}
              <Button
                type="submit"
                disabled={(dirty && !isValid) || isSubmitting}
              >
                {isSubmitting ? 'Submitting ...' : submitText}
              </Button>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

export default LeadForm;



// WEBPACK FOOTER //
// ./src/reactModules/shared/LeadForm/index.js